import React, { useEffect } from "react";

import MasterFinyearTable from "./MasterFinyearTable";
import MasterFinyearAdd from "./MasterFinyearAdd";
import MasterFinyearEdit from "./MasterFinyearEdit";

import Breadcrumbs from "../../../components/ui/Breadcrumbs";
import DeleteAlert from "../../../components/ui/DeleteAlert";

import useApiNew from "../../../utils/useApiNew";
import Notification, {
  errorNotify,
  successNotify,
} from "../../../Services/Notification";
import axios from "axios";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";

const finyearApiURL = `${process.env.REACT_APP_API_URL}api/finyear`;
const exportFinyearApiURL = `${process.env.REACT_APP_API_URL}api/export-finyear`;

const MasterFinyear = () => {
  const [renderKey, setRenderKey] = React.useState(0);
  const [isAdd, setIsAdd] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [selectedItemId, setSelectedItemId] = React.useState();
  const [globalFilters, setGlobalFilters] = React.useState();
  const [bankData, setBankData] = React.useState();
  const [isButtonClicked, setIsButtonClicked] = React.useState();
  const [isDownloadClicked, setIsDownloadClicked] = React.useState();

  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  let { data, loading } = useApiNew(
    finyearApiURL,
    "GET",
    { headers },
    renderKey,
  );

  data = data?.map((item) => ({
    ...item,
    status: item.status ? "Active" : "Inactive",
  }));

  const filterBankData = () => {
    let filterData = data;
    if (globalFilters) {
      filterData = data.filter(
        (item) =>
          item?.fin_year_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.fin_year_short_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.status?.toLowerCase() === globalFilters?.toLowerCase(),
      );
    }
    setBankData(filterData);
  };
  useEffect(() => {
    filterBankData();
  }, [globalFilters]);

  // ADD
  const handleAddFinyear = async (data) => {
    setIsButtonClicked(true);
    try {
      const res = await axios.post(finyearApiURL, data, { headers });
      const resData = res.data;

      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // EDIT

  const handleEditFinyear = async (segmentId, data) => {
    setIsButtonClicked(true);
    const updateAPI = `${finyearApiURL}/${segmentId}`;

    try {
      const res = await axios.put(updateAPI, data, { headers });
      const resData = res.data;
      console.log(resData);

      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // DELETE

  const handleDeleteFinyear = async () => {
    const deleteAPI = `${finyearApiURL}/${selectedItemId}`;

    try {
      const res = await axios.delete(deleteAPI, { headers });
      const resData = res.data;
      triggerRerender();

      if (!resData.error) {
        successNotify("Data deleted.");
        setIsDelete(false);
        return true;
      } else {
        errorNotify(resData?.message);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }
  };

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);

  const downloadExcel = async (filename) => {
    try {
      const apiEndpoint = exportFinyearApiURL;
      const headers = {
        Authorization: `Bearer ${
          sessionStorage.getItem("subscriberToken")
            ? sessionStorage.getItem("subscriberToken")
            : sessionStorage.getItem("token")
        }`,
      };
      const response = await axios.get(apiEndpoint, {
        headers,
        responseType: "blob",
      });

      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename; // Set the filename here

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setIsDownloadClicked(false);
      } else {
        console.error("Invalid response or missing data");
        setIsDownloadClicked(false);
      }
    } catch (error) {
      errorNotify("Something went wrong.");
      setIsDownloadClicked(false);
    }
  };

  // DOWNLOAD
  const downloadFinyear = () => {
    setIsDownloadClicked(true);
    const filename = `Finyear-Master_${formattedDate}.xlsx`;
    downloadExcel(filename);
  };

  const breadcrumbs = ["Home", "Master", "Financial Year"];

  const buttonConfig = {
    value: "financial_year",
    name: "Financial Year",
    addHandler: handleAddFinyear,
    editHandler: handleEditFinyear,
    deleteHandler: handleDeleteFinyear,
    downloadHandler: downloadFinyear,
    closeAddModal: () => setIsAdd(false),
    closeEditModal: () => setIsEdit(false),
  };

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />

      <MasterFinyearTable
        tableData={globalFilters ? bankData : data}
        buttonConfig={buttonConfig}
        setIsAdd={setIsAdd}
        setIsEdit={setIsEdit}
        setIsDelete={setIsDelete}
        setSelectedItemId={setSelectedItemId}
        renderKey={renderKey}
        setGlobalFilters={setGlobalFilters}
        loading={loading}
        actionPermissions={actionPermissions("masters", "Financial Year")}
        isDownloadClicked={isDownloadClicked}
      />

      {isAdd && (
        <MasterFinyearAdd
          buttonConfig={buttonConfig}
          isButtonClicked={isButtonClicked}
        />
      )}

      {isEdit && (
        <MasterFinyearEdit
          finyearData={data}
          buttonConfig={buttonConfig}
          selectedItemId={selectedItemId}
          isButtonClicked={isButtonClicked}
        />
      )}

      {isDelete && (
        <DeleteAlert
          closeHandler={() => setIsDelete(false)}
          deleteHandler={buttonConfig.deleteHandler}
        />
      )}
    </div>
  );
};

export default MasterFinyear;
